import range from 'lodash/range';
import React from 'react';
import ContentLoader from 'react-content-loader';
import styled from 'styled-components';

const THUMB_HEIGHT = 32;
const StyledContentLoader = styled(ContentLoader)`
  display: flex;
  height: ${THUMB_HEIGHT}px;
`;

export const ThumbLoader = ({ count = 5 }) => (
  <StyledContentLoader viewBox={`0 0 ${count * 36} ${THUMB_HEIGHT}`}>
    {range(count).map(item => (
      <rect key={item} x={36 * item} y="0" rx="4" ry="4" width="32px" height="100%" />
    ))}
  </StyledContentLoader>
);
